export const en_overrides_strings = {
  'err.phone_nr.pattern': 'Invalid phone number. Accepted formats: local phone number (10 digits) or international number (with country code starting with + or 00)'
};
